var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('report-description-card', {
    attrs: {
      "minLength": 35,
      "maxLength": 1000,
      "screen": _vm.screen
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }